import React from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, Col, Row } from "reactstrap";
import { formatCurrency } from "../formatters";
import type { SummaryCard } from "../types";

type SummaryAccordionProps = {
  cards: SummaryCard[];
  isOpen: boolean;
  onToggle: () => void;
  isDisabled: boolean;
};

const SummaryAccordion = ({ cards, isOpen, onToggle, isDisabled }: SummaryAccordionProps) => {
  if (cards.length === 0) {
    return null;
  }

  return (
    <Accordion
      flush
      className="mb-4"
      open={isOpen ? "summary" : ""}
      toggle={onToggle}
    >
      <AccordionItem>
        <AccordionHeader targetId="summary">
          <span className="fw-semibold">Indicadores resumidos</span>
        </AccordionHeader>
        <AccordionBody accordionId="summary">
          <Row className="row-cols-xxl-6 row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-1 g-3">
            {cards.map((card) => (
              <Col key={card.id}>
                <Card className="crm-widget bg-light-subtle border-0 shadow-sm h-100">
                  <CardBody className="py-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p className="text-muted text-uppercase fs-12 fw-semibold mb-0">
                        {card.label}
                      </p>
                      <i
                        className={
                          isDisabled
                            ? "ri-information-line text-muted"
                            : card.trendIcon
                        }
                      ></i>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <span className="avatar-sm rounded-circle bg-light d-inline-flex align-items-center justify-content-center">
                          <i
                            className={`${card.icon} ${
                              isDisabled
                                ? "text-muted"
                                : `text-${card.iconColor}`
                            } fs-4`}
                          ></i>
                        </span>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h4
                          className={`mb-1 ${isDisabled ? "text-muted" : ""}`}
                        >
                          {isDisabled && card.value === 0
                            ? "—"
                            : formatCurrency(card.value)}
                        </h4>
                        {card.helper ? (
                          <small
                            className={
                              isDisabled
                                ? "text-muted"
                                : "text-muted"
                            }
                          >
                            {card.helper}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};

export default SummaryAccordion;
